var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Menu'),_c('div',{attrs:{"id":"centre"}},[_c('MenuProfil'),_c(_vm.layout,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }